export default "__VITE_PUBLIC_ASSET__6b348d0d__"